import React from "react";
import './Scholarships.css';

class Scholarships extends React.Component {
    render() {
        return (
            <article className="article br3 ba b--black-10 w-100 w-50-m w-50-l mw7 shadow-5 center">
                <main className="pa4 black-80">
                    <div className="measure">
                        <fieldset id="sign_up" className="ba b--transparent ph0 mh0">
                            <div className='legend center'>
                                <legend className="f1 fw6 ph0 mh0">المنح</legend>
                            </div>
                            <hr/>

                            <div className="ui form ma0">
                                <div className="fields">
                                    <h3>
                                        الشباب اللي بيدور علي منحة ومش عارف الخطوات ويبدا منين وازاي ..هتعرف ازاي تقدم على المنحة وتحصل عليها باذن الله
                                        <br/>
                                        <br/>
                                        و لينكات <a target='_blank' rel="noreferrer" href='https://www.facebook.com/groups/311111149267612/permalink/437647313280661/'>DAAD EGYPT</a> معلومات مهمة عن المنح 
                                        <br/>
                                        <br/>
                                        <a target='_blank' rel="noreferrer" href='https://www.youtube.com/watch?v=WZ8rCNcKIwQ'>الفيديو الاول</a> هتعرف فيه انوع الجهات اللى بتقدم المنح و ازاى تبحث عنها و الخطوات 
                                        <br/>
                                        <br/>
                                        <a target='_blank' rel="noreferrer" href="https://www.youtube.com/watch?v=LQv6Skjtafo">الفيديو التانى</a> هتعرف ازاى تجد منحة في التخصص الذي ترغب فيه من موقع Daad.de
                                        <br/>
                                        <br/>
                                        <a target='_blank' rel="noreferrer" href='https://www.youtube.com/watch?v=bAa-b3RtxYQ&t=517s'>الفيديو التالت</a> تجربة الحصول على منحة من الدااد و أهم متطلبات المنح و الخطوات
                                        <br/>
                                        <br/>
                                        <a target='_blank' rel="noreferrer" href='https://www.facebook.com/100006402372164/videos/2009089565981103/'>الفيديو الرابع</a> كل تفاصيل واجراءات الحصول على
                                        (الدااد Daad مصر) منحة 
                                        <br/>
                                        <br/>
                                        و المواقع دى ممكن تفيدكم
                                        <br/>
                                        <div className='lft'>
                                            <a target='_blank' rel="noreferrer" href='http://mentorks.net/'>mentorks.net</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='http://www.mina7.net/ar/'>mina7.net/ar</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='http://www.scholarshipportal.com/'>scholarshipportal.com</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='http://scholarship-positions.com/'>scholarship-positions.com</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='http://www.bibalex.org/he_funding/Home/'>bibalex.org/he_funding/Home</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='https://www.sasapost.com/studyabroad-grants/'>sasapost.com/studyabroad-grants</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='http://www.arabscholar.net/'>arabscholar.net</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='https://www.hotcourses.ae/'>hotcourses.ae</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='http://www.scholars4dev.com/'>scholars4dev.com</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='https://www.youthop.com/'>youthop.com</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='http://cscuk.dfid.gov.uk/'>cscuk.dfid.gov.uk</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='http://edlibre.com/'>edlibre.com</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='https://www.heysuccess.com/'>heysuccess.com</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='http://scholarshipfellow.com/'>scholarshipfellow.com</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='http://www.scholarshipcare.com/'>scholarshipcare.com</a>
                                            <br/>
                                            <a target='_blank' rel="noreferrer" href='http://scholarshipfellow.com/'>scholarshipfellow.com</a>
                                        </div>
                                    </h3>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </main>
            </article>
        );
    }
}

export default Scholarships;
